module.exports = __webpack_public_path__ + "static/media/05B.95207404.png";